import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["map", "select", "viewAlignment"]
  static values = {prefix: String}

  connect() {
    this.prefixBase = this.normalizePrefixValue()
    this.fetchMap()
  }

  normalizePrefixValue() {
    // Read directly from data attribute as fallback
    const dataAttr = this.element.dataset.curriculum2PrefixValue
    const raw = this.hasPrefixValue ? this.prefixValue : dataAttr || "/curriculum"
    const trimmed = raw.replace(/\/+$/, "")
    const withLeading = trimmed.startsWith("/") ? trimmed : `/${trimmed}`
    return withLeading.length > 0 ? withLeading : "/curriculum"
  }

  pathFor(slug) {
    const base = this.prefixBase === "/" ? "" : this.prefixBase
    const sanitizedSlug = slug.replace(/^\/+/, "")
    return `${base}/${sanitizedSlug}`
  }

  fetchMap() {
    const mapTarget = this.mapTarget
    fetch("/images/united-states-map.svg")
      .then((response) => response.text())
      .then((html) => {
        mapTarget.innerHTML = html
        this.rewriteMapLinks()
      })
  }

  rewriteMapLinks() {
    const anchors = this.mapTarget.querySelectorAll('a[href^="/curriculum/"]')
    anchors.forEach((anchor) => {
      const href = anchor.getAttribute("href")
      const slug = href.split("/").pop()
      if (slug) {
        anchor.setAttribute("href", this.pathFor(slug))
      }
    })
  }

  onChange(e) {
    const link = this.viewAlignmentTarget
    const selectValue = this.selectTarget.value

    if (!selectValue) {
      link.setAttribute("disabled", "true")
      return
    }

    const state = selectValue.toLowerCase()
    link.removeAttribute("disabled")
    link.disabled = false

    link.href = this.pathFor(state)
  }

  selectTerritory(e) {
    const territory = e.currentTarget.dataset.territory
    if (territory) {
      this.selectTarget.value = territory.toUpperCase()
      const link = this.viewAlignmentTarget
      link.removeAttribute("disabled")
      link.disabled = false
      link.href = this.pathFor(territory)
    }
  }
}
